import createDownloadInstance from '../libs/axios-download.js'
const instanceDownload = createDownloadInstance('https://oboynogo6f.execute-api.sa-east-1.amazonaws.com/production')
export default instanceDownload